import { IBlock } from "framework/src/IBlock";
// Customizable Area Start
import React from "react"
import { Message } from "framework/src/Message";
import { BlockComponent } from "framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "framework/src/Messages/MessageEnum";
import { runEngine } from "framework/src/RunEngine";
import { getStorageData } from "framework/src/Utilities";
import { Account, StoryViewer} from "../../broadcastmessage/src/BroadcastMessageController.web";
import { Stories } from "./CrerateHighlightStoriesController.web";
import { IHighlights } from "./ProfileController.web";

interface IStoriesResponse{
  data:Array<Stories>
}

interface IError{
  errors:Array<string>
}

interface IDeleteHighlightResp {
  message:string
}
interface PaginationDetails {
    page_number: number;
    records_in_this_page: number;
    records_per_page: number;
    total_pages: number;
    total_records: number;
  }


  interface Media {
    id: number;
    url: string;
    filename: string;
    content_type: string;
  }
  
  export interface OwnerStory {
    id: string;
    type: string;
    attributes: {
    id: number;
    body: string;
    media: Media;
    created_at: string;
    is_viewed: boolean;
    hash_tags: string[];
    is_liked:boolean|null,
    body_mentions: string[];
    view_count: number;
    };
  }

  export interface IStoryViewrResponse{
    data:Array<StoryViewer>
    pagination_details:PaginationDetails
  }

export interface IUserAttributes{
    full_name:string,
    profile_photo:string|null
}
// Customizable Area End
export const configJSON = require("./config");

export interface Props {
    navigation: any;
    id: string;
    // Customizable Area Start
    checked:boolean;
    open:boolean;
    HighlightId?:IHighlights
    onClose:()=>void;
    classes:{[key:string]:string}
    onDeleteHighlight?:()=>void;
    onEditHighlight?:(HighlightId:IHighlights)=>void;
    isLoggedUser?:boolean
    userInfo:IUserAttributes
    isArchiovedView?:boolean;
    ArchivedStory?:Array<Stories>;
    selectedItem?:number
    // Customizable Area End
  }
  
  interface S {
     // Customizable Area Start
     showViewer:boolean
     isPlaying:boolean
     isMuted:boolean
     isModel:boolean
     timer: null |NodeJS.Timer
     progress:number,
     replyMessage:string,
     ownerStories:Array<Stories>,
     selectedItem:number
     page:number
     viewerPagination:PaginationDetails,
     userStories:Array<Account>,
     isLoading:boolean,
     isDisabled:boolean
     childIndex:number,
     isOwnerModel:boolean
     userInfo:{}|IUserAttributes,
     viewerList:StoryViewer[],
     showFullText:boolean,
     Menu:boolean
     deleteModal:boolean,
     currentStoryId:number
    // Customizable Area End
  }
  
  interface SS {
    // Customizable Area Start
     id: any;
    // Customizable Area End
  }
  
export default class HighlightedStoriesController extends BlockComponent<
  Props,
  S,
  SS
> {
  // Customizable Area Start
  seenOwnerStoriesApiCallId:string=""
  seenStoriesApiCallId:string=""
  UnlikeStoryApiCallId:string=""
  likeStoryApiCallId:string=""
  getHighlightApiCallId:string=""
  deleteHighlightApiCallId:string=""
  scrollViewerStoryParentRef = React.createRef<HTMLDivElement>();
  // Customizable Area End

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    // Customizable Area Start
    // Customizable Area End

    this.subScribedMessages = [
      getName(MessageEnum.AccoutLoginSuccess),
      // Customizable Area Start
      getName(MessageEnum.RestAPIResponceMessage),
      // Customizable Area End
    ];

    this.state = {
      // Customizable Area Start
    showViewer:false,
    isPlaying:true,
    isMuted:false,
    isModel:false,
    timer:null,
    progress:0,
    replyMessage:'',
    selectedItem:0,
    page:1,
    ownerStories:[],
    viewerPagination:{
        page_number: 0,
        records_in_this_page: 0,
        records_per_page: 0,
        total_pages: 0,
        total_records: 0        
      },
      userStories:[],
      isLoading:false,
      isDisabled:false,
      childIndex:0,
      userInfo:{},
      viewerList:[],
      isOwnerModel:false,
      showFullText:false,
      Menu:false,
      deleteModal:false,
      currentStoryId:0
      // Customizable Area End
    };
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);

    // Customizable Area Start
    // Customizable Area End
  }

  async receive(from: string, message: Message) {
    // Customizable Area Start
    runEngine.debugLog("Message Recived", message);
    let apiRequestCallId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );

    let responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    this.handleResponse(apiRequestCallId,responseJson)
    // Customizable Area End
  }

  // Customizable Area Start
  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<S>): void {
      if(prevProps.open!==this.props.open){
        if(this.props.open){
            this.setState({
                isMuted:false,
                userInfo:this.props.userInfo,
                isPlaying:true
            }, this.resetProgress)
            if(this.props.isArchiovedView){
              this.setState({
                ownerStories:this.props.ArchivedStory??[],
                selectedItem:this.props.selectedItem??0
              },this.startProgress)
            }else{
             this.getHighlightStories()
            }
        }else{
          this.resetProgress()
          this.setState({
            ownerStories:[],
            selectedItem:0,
            isMuted:false,
          })
        }
      }
  }


  handlelViewerClose =()=>{
    this.setState({
        showViewer:false,
    })
    this.handleNextClick()
    this.togglePlayPause()
  }


  handlelClose =()=>{
    this.setState({
        isModel:false,
        isPlaying:true,
        isMuted:true,
    })
    this.props.onClose()
   }
    

   muteHandler =()=>{
    this.setState({isMuted:!this.state.isMuted})
  }


  startProgress = () => {
    clearInterval(this.state.timer as unknown as number); 
    if (this.state.isPlaying) {
    const interval = setInterval(() => {
      this.setState(prevState => ({progress: prevState.progress + (100 / 300)}), () => {
        if (this.state.progress >= 100) {
          clearInterval(this.state.timer as unknown as number);
          this.setState({ progress: 100})
        }
      });
    }, 100); 
    this.setState({ timer: interval as NodeJS.Timer });
  }
  };
  
  pauseProgress = () => {
    clearInterval(this.state.timer as unknown as number);
    this.setState({ isPlaying: false });
  };

  togglePlayPause = () => {
    this.setState(prevState => {
      if (prevState.isPlaying) {
        this.pauseProgress();
      } else {
        this.setState({ isPlaying: true }, this.startProgress);
      }
    });
  };

   getHoursDifference = (dateString:string) => {    
    const createdAt = new Date(dateString) as unknown as number;
    const now = new Date() as unknown as number;
    const diffInMilliseconds = now - createdAt;
    const seconds = Math.floor(diffInMilliseconds / 1000);

    const intervals = [
      { label: "year", seconds: 31536000 },
      { label: "month", seconds: 2592000 },
      { label: "week", seconds: 604800 },
      { label: "day", seconds: 86400 },
      { label: "hour", seconds: 3600 },
      { label: "minute", seconds: 60 },
    ];
  
    for (const interval of intervals) {
      const count = Math.floor(seconds / interval.seconds);
      const diff = Math.floor(seconds/60*60)
        if(diff<1){
         return "just now"
        }else if (count >= 1) {
        return `${count} ${interval.label}${count > 1 ? "s" : ""} ago`;
      }
   };
  }

   conditionFilter = (condition:boolean,trueStatement:string,falseStatement:string) =>{
    return condition ?  trueStatement :falseStatement
   }


   handleUnLikeStory  = async(id:number,isLiked:boolean)=>{
    this.setState({
      currentStoryId:id
    })
    let token = await getStorageData("authToken")
    const type = isLiked?configJSON.httpDeleteMethod:configJSON.httpPostMethod
    const header = {
      "Content-Type": configJSON.jsonApiContentType,
      token:token,
    };
   
  
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
  
    let httpBody ={
      likeable_id:id,
      likeable_type:'story'  
     }

     if(isLiked){
      this.UnlikeStoryApiCallId = requestMessage.messageId
     }else{
      this.likeStoryApiCallId= requestMessage.messageId;
     }
  
    requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), configJSON.likePostEndpoint);
    requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage),JSON.stringify(header));
    requestMessage.addData(getName(MessageEnum.RestAPIRequestBodyMessage),JSON.stringify(httpBody));
    requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage),type);
    runEngine.sendMessage(requestMessage.id, requestMessage) 
   }

   handleView=(id:number)=>{
    this.pauseProgress()
    this.setState(
      {showViewer:true,currentStoryId:id},
      ()=>this.handleSeenOwnStories(id))
  }

  handleSeenOwnStories =async(id:number) =>{

    if(this.state.currentStoryId!==id){
      this.setState({
        page:1,
        viewerList:[],
        viewerPagination:{
          page_number: 0,
          records_in_this_page: 0,
          records_per_page: 0,
          total_pages: 0,
          total_records: 0        
        },
      })
    }
    let token = await getStorageData("authToken")
    let user_details =  id

    const header = {
      "Content-Type": configJSON.jsonApiContentType,
      token:token,
    };
  
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.seenOwnerStoriesApiCallId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.getownSennStoriesAPiEndPoint+`?id=${user_details}&page=${this.state.page}&_limit=15&sort_order=desc`
    );
  
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
  
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpGetMethod
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
  
  }


  deleteHighlight=async()=>{
    let token = await getStorageData("authToken")
    const header = {
      "Content-Type": configJSON.jsonApiContentType,
      token:token,
    };
  
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.deleteHighlightApiCallId= requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.addHighlightEndPoint+`/${this.props.HighlightId?.id}`
    );
  
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
  
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpDeleteMethod
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
  }



  getHighlightStories =async() =>{
    let token = await getStorageData("authToken")
    const header = {
      "Content-Type": configJSON.jsonApiContentType,
      token:token,
    };
  
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.getHighlightApiCallId= requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.addHighlightEndPoint+`/${this.props.HighlightId?.id}`
    );
  
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
  
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpGetMethod
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
  
  }

  setShowFullText =()=>{
    this.setState({showFullText:!this.state.showFullText})
   }



   handlePrev =()=>{
    if (this.state.childIndex > 0) {
      setTimeout(()=>{
        this.setState({ isPlaying: true,childIndex:this.state.childIndex?this.state.childIndex-1:0,isMuted:true,showFullText:false,isDisabled:false},()=>{
          this.startProgress(); 
          this.handleSeenStories()
       }) 
      },500)     
  
    } else if(this.state.selectedItem>0){ 
    setTimeout(()=>{
      this.setState({ selectedItem:this.state.selectedItem?this.state.selectedItem-1:0,isPlaying: true,childIndex:0,isMuted:true,showFullText:false,isDisabled:false},()=>{
        this.startProgress(); 
        this.handleSeenStories()
     }) 
    },500) }
   }


  
   handlePrevClick = () => {
    this.setState({isDisabled:true})
    this.resetProgress();   
    if(this.props.open){
     this.handlePrev()
  }else{
    if (this.state.selectedItem > 0) {
      setTimeout(()=>{
        this.setState({ isPlaying: true,isMuted:true,selectedItem: this.state.selectedItem?this.state.selectedItem-1:0,showFullText:false,isDisabled:false},()=>{
          this.startProgress(); 
    
       }) 
      },500)    
    } 
  }
    
  };

  handleResponse=(apiRequestCallId:string,responseJson:IStoryViewrResponse&IDeleteHighlightResp& IStoriesResponse&IError)=>{

    switch(apiRequestCallId){
     case this.getHighlightApiCallId:
        return this.handlegetHighlight(responseJson)
     
     case this.deleteHighlightApiCallId:
      return this.handleDeleteHighlight(responseJson)
     
     case this.seenOwnerStoriesApiCallId:
      return this.handleSeenOwnStoriesResponse(responseJson)

      case this.likeStoryApiCallId:
      return this.handleLikedStories(responseJson)

      case this.UnlikeStoryApiCallId:
      return this.hanldeUnLikedStories(responseJson)

    }
  }


  hanldeUnLikedStories=(responseJson:IDeleteHighlightResp& IError)=>{
    if(!responseJson?.errors){
    const userStories = this.state.ownerStories.map(item=>item.attributes.id===this.state.currentStoryId?{
      ...item,attributes:{...item.attributes,is_liked:false}
    }:{...item})
    this.setState({
      ownerStories:userStories
    })
  }
  }

  handleLikedStories=(responseJson:IDeleteHighlightResp& IError)=>{
    if(!responseJson?.errors){
    const userStories = this.state.ownerStories.map(item=>item.attributes.id===this.state.currentStoryId?{
      ...item,attributes:{...item.attributes,is_liked:true}
    }:{...item})
    this.setState({
      ownerStories:userStories
    })
  }
  }

  handleSeenOwnStoriesResponse=(responseJson:IStoryViewrResponse& IError)=>{
    if(!responseJson?.errors){
      this.setState((prev)=>({viewerList:[...this.state.viewerList,...responseJson.data],
        viewerPagination:responseJson.pagination_details,page:prev.page+1}))
    }
  }

  handleDeleteHighlight=(responseJson:IDeleteHighlightResp & IError)=>{
     if(!responseJson.errors){
      this.props.onDeleteHighlight&&this.props.onDeleteHighlight()
       this.setState({
         Menu:false,
         deleteModal:false
       })
       this.props.onClose()
     }
  }
  
  handlegetHighlight=(responseJson:IStoriesResponse&IError)=>{
    if(!responseJson?.errors){
     this.setState({
      ownerStories:responseJson.data
     },this.startProgress) 
    }
  }



   resetProgress = () => {
    clearInterval(this.state.timer as unknown as number);
    this.setState({ progress: 0 ,timer: null});
  };
  

  handleEdit=()=>{
    if(this.props.HighlightId)
    this.props.onEditHighlight && this.props.onEditHighlight(
      this.props.HighlightId
    )
    this.props.onClose()
    this.setState({
      Menu:false,
      deleteModal:false,
    })
  }
  
  openDeleteModal=()=>{
    this.setState({
      deleteModal:true,
      Menu:false
    })
  }

  onMenuclose=()=>{
    this.setState({
      Menu:false
    })
  }

   handleSendMessage =()=>{
    this.setState({replyMessage:"",isPlaying: true},()=>{
      this.startProgress()
    })
   }


   handleSeenStories =async() =>{
    let token = await getStorageData("authToken")
    let user_details =  this.state.ownerStories[this.state.selectedItem]
    if(user_details.attributes.is_viewed) {
      return
    }
    const header = {
      "Content-Type": configJSON.jsonApiContentType,
      token:token,
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.seenStoriesApiCallId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `${configJSON.getStoriesAPiEndPoint}/${user_details?.id}`
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpGetMethod
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);

  }

   
   handleNextClick = () => {
    this.setState({isDisabled:true})
    this.resetProgress();
    if (this.state.selectedItem <this.state.ownerStories.length-1) {
      setTimeout(()=>{
        this.setState({ isPlaying: true,isMuted:true,selectedItem: this.state.selectedItem+1,showFullText:false,isDisabled:false},()=>{
          this.startProgress();   
          this.handleSeenStories()
       }) 
      },500)    
    } else{
      this.handlelClose()
    }
  };

   handleChangeMessage =(event:React.ChangeEvent<HTMLInputElement>) =>{
    if(event.target.value){
    this.setState({replyMessage:event.target.value},()=>{
      this.pauseProgress()
   })}else{
    this.setState({replyMessage:event.target.value,isPlaying: true},()=>{
       this.startProgress()
    })
   }}


   MenuHandler = ()=>{
    this.setState({
      Menu:true
    })
  }


  onDeleteClose=()=>{
    this.setState({
      deleteModal:false
    })
  }
  // Customizable Area End
}